<template>
  <b-row class="dashboard-indicadores-historico-ventas">
    <b-col cols="12">
      <label class="titulo" v-if="showTitulo">{{ titulo }}</label>
      <b-table hover
          responsive="sm" 
          class="registro"
          :busy="tableBusy"
          :items="indicadoresVentas" 
          :fields="indicadoresVentasFields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>
        <template v-slot:cell(montoObjetivo)="data">
          <!-- {{ data.item.montoObjetivo | moneda }} -->
        </template>
        <template v-slot:cell(montoActual)="data">
          {{ data.item.montoActual | moneda }}
        </template>
        <template v-slot:cell(pjeActualObjetivo)="data">
          <!-- {{ data.item.pjeActualObjetivo | porcentaje }} -->
        </template>

        <template v-slot:cell(opciones)="data"
            v-if="verDatosVentas">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template slot="button-content">
              <i class="fa fa-ellipsis-v"></i>
            </template>

            <b-dropdown-item 
                @click.stop="exportarComprobantes(data.item)">
              <i class="fa fa-file-excel-o"></i>Exportar Comprobantes</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </b-col>
  </b-row>
</template>

<script>

export default {
  props: {
    totalNegocio: {
      type: Boolean,
      default: false
    },
    showTitulo: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      indicadoresVentas: [],

      indicadoresVentasFields: [
        // { key: 'fechaDesde' },
        // { key: 'fechaHasta' },
        { 
          key: 'indicadorPeriodo',
          label: 'Periodo' 
        },
        { 
          key: 'montoObjetivo',
          class: 'text-right'
        },
        { 
          key: 'montoActual',
          label: 'Monto Real',
          class: 'text-right'
        },
        // { 
        //   key: 'pjeObjetivo',
        //   label: 'Pje Objetivo',
        //   class: 'text-right'
        // },
        { 
          key: 'pjeActualObjetivo',
          label: 'Pje Real',
          class: 'text-right'
        },
        { 
          key: 'descripcion',
          label: 'Descripción'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        }
      ],

      tableBusy: false,
      verDatosVentas: false
    }
  },
  computed: {
    titulo() {
      if ((/true/i).test(this.totalNegocio)) {
        return 'Ventas Anual';
        // return 'Ventas - Total Negocio';
      }

      return 'Ventas Anual - Sin Reembolsos';
      // return 'Ventas';
    }
  },
  created() {
    let userRolId = parseInt(this.$store.getters['user/rolId']);

    switch (userRolId) {
        case 1: /* Superadministrador */
        case 2: /* Direccion */
        case 8: /* Calidad */
        case 9: /* Director Ejecutivo */
        case 19: /* Coordinador/a comercial */
        case 20: /* Gerente comercial */
        case 22: /* Responsable de Facturacion e Impuestos */
        case 23: /* Asistente de Calidad */
          this.verDatosVentas = true;
          break;
    }    
  },
  methods: {
    getIndicadores() {
      let dispatch = 'resultadosVentas/getIndicadoresVentasAnualHistorico';
      let getter = 'resultadosVentas/indicadoresVentasAnualHistorico';

      if ( (/true/i).test(this.totalNegocio)) {
        dispatch = 'resultadosVentas/getIndicadoresVentasAnualHistoricoTotal';
        getter = 'resultadosVentas/indicadoresVentasAnualHistoricoTotal';
      }

      this.tableBusy = true;
      this.$store.dispatch(dispatch)
        .then(() => {
          this.indicadoresVentas = this.$store.getters[getter];
          this.tableBusy = false;
        });
    },
    exportarComprobantes(item) {
      let params = {
        fechaDesde: item.fechaDesde,
        fechaHasta: item.fechaHasta,
      }

      this.showSpinner();
      this.$store.dispatch('resultadosVentas/getIndicadorVentasHistoricoComprobantes', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosVentas/resultados'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Detalle de Ventas';
            let fileName = 'ventas';
            let format = [
              { titulo: 'Fecha Comprobante', nombre: 'fechaComprobante', formato: 'fecha' },
              { titulo: 'Fecha Imputación', nombre: 'fechaImputacionIndicadores', formato: 'fecha' },
              { titulo: 'Cliente', nombre: 'cliente', formato: '' },
              { titulo: 'Comprobante', nombre: 'comprobante', formato: '' },
              { titulo: 'Numero', nombre: 'numero', formato: '' },
              { titulo: 'Monto Neto', nombre: 'montoNeto', formato: '' },
              { titulo: 'Neto S/Reembolsos', nombre: 'montoNetoSinReembolsos', formato: '' },
              { titulo: 'Neto Reembolsos', nombre: 'montoNetoReembolsos', formato: '' },
              { titulo: 'Presupuestos', nombre: 'presupuestosInternos', formato: '' }
            ];

            this.exportXLS(title, fileName, rptComprobantes, format);
          } else {
            console.log('No hay datos para exportar.');
          }
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        })
        .finally(() => this.hideSpinner());
    }    
  }
}
</script>

<style>
  .dashboard-indicadores-historico .dashboard-indicadores-historico-ventas .registro table td[aria-colindex="1"] 
  {
    width: 20%;
  }
  .dashboard-indicadores-historico .dashboard-indicadores-historico-ventas .registro table td[aria-colindex="2"],
  .dashboard-indicadores-historico .dashboard-indicadores-historico-ventas .registro table td[aria-colindex="3"] 
  {
    width: 15%;
  }
  .dashboard-indicadores-historico .dashboard-indicadores-historico-ventas .registro table td[aria-colindex="4"] 
  {
    width: 10%;
  }
  .dashboard-indicadores-historico .dashboard-indicadores-historico-ventas .registro table td[aria-colindex="5"] 
  {
    width: calc(25% - 30px);
  }
  .dashboard-indicadores-historico .dashboard-indicadores-historico-ventas .registro table td[aria-colindex="6"] 
  {
    width: 30px;
  }

</style>